const defaultConfig = {
  "AUTH0_DOMAIN": "voyager.au.auth0.com",
  "AUTH0_CLIENT_ID": "TjeDW2r7DpidMf6D4zID8Ta5PsnbetAx",
  "AUTH0_RESPONSE_TYPE": "token id_token",
  "AUTH0_SCOPE": "openid",
  "TTL_MAX_VAL": 36400,
  "TTL_MIN_VAL": 0,
  "PRIORITY_MAX_VAL": 255,
  "PRIORITY_MIN_VAL": 0
};

const runtimeConfig = window.config || {};

export default {
  ...defaultConfig,
  ...runtimeConfig
};
